/**
 * CollectionMain - collection page product grid; re-renders on filter changes.
 * Custom element: <collection-main>
 *
 * Refs:
 *   [data-ref="loading"]  (optional)
 *   [data-ref="loadMore"]  (optional)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import "./component-LoadMore.js";
import "./component-LoadingSpinner.js";
import { ThemeComponent, collection, scrollToElement } from "./theme.js";
import "./vendor.js";
class CollectionMain extends ThemeComponent {
  init() {
    this.loadMore && (this.$subscribe(collection.onChange, async () => {
      await this.reload(), this.findNewLoadMoreComponents();
    }), this.subscribeToLoadMoreLoading());
  }
  async reload() {
    this.setLoading(!0);
    const renderedSections = await collection.render(["collection-main"]),
      parsedContainer = document.createElement("div");
    parsedContainer.innerHTML = renderedSections["collection-main"];
    const newProductCount = parsedContainer.querySelector(".collection-filtering-sorting__product-count"),
      existingProductCount = document.querySelector(".collection-filtering-sorting__product-count");
    newProductCount && existingProductCount && (existingProductCount.outerHTML = newProductCount.outerHTML);
    const newFilterToggle = parsedContainer.querySelector(".collection-filtering-sorting__filter-toggle__button"),
      existingFilterToggle = document.querySelector(".collection-filtering-sorting__filter-toggle__button");
    newFilterToggle && existingFilterToggle && (existingFilterToggle.innerHTML = newFilterToggle.innerHTML);
    const newContainer = parsedContainer.querySelector(".collection-main__container"),
      existingContainer = this.querySelector(".collection-main__container");
    newContainer && existingContainer && (existingContainer.outerHTML = newContainer.outerHTML), scrollToElement(this), this.setLoading(!1);
  }
  setLoading(isLoading = !1) {
    var spinnerToShow, spinnerToHide;
    isLoading ? (spinnerToShow = this.loading) == null || spinnerToShow.classList.add("is-active") : (spinnerToHide = this.loading) == null || spinnerToHide.classList.remove("is-active");
  }
  subscribeToLoadMoreLoading() {
    for (const loadMoreComponent of this.loadMore) this.$subscribe(loadMoreComponent.onLoading, loadingState => {
      this.setLoading(loadingState);
    }), loadMoreComponent.setAttribute("data-has-loading-listener", "true");
  }
  findNewLoadMoreComponents() {
    const loadMoreElements = this.querySelectorAll('[data-ref="loadMore"]');
    for (const loadMoreElement of loadMoreElements) if (!loadMoreElement.hasAttribute("data-has-loading-listener")) {
      const loadMoreComponent = loadMoreElement;
      this.$subscribe(loadMoreComponent.onLoading, loadingState => {
        this.setLoading(loadingState);
      }), loadMoreElement.setAttribute("data-has-loading-listener", "true");
    }
  }
}
setFunctionName(CollectionMain, "CollectionMain");
const propertyTypes = {};
CollectionMain.prototype.$name = "CollectionMain";
CollectionMain.prototype.$info = JSON.parse('{"name":"CollectionMain","meta":{"isLegacy":false,"selector":"collection-main"},"props":[],"refs":[{"selector":"[data-ref=\\"loading\\"]","required":false,"propertyKey":"loading","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"LoadingSpinner"},{"selector":"[data-ref=\\"loadMore\\"]","required":false,"propertyKey":"loadMore","propertyType":"Array","propertyTypeName":"Array","propertyTsTypeName":"LoadMore[]"}]}');
CollectionMain.prototype.$info.component = CollectionMain;
for (const prop of CollectionMain.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Collection/CollectionMain.ts", {
  CollectionMain: CollectionMain
}, void 0);